import { render } from "./LoginFormEmail.vue?vue&type=template&id=87fab222&scoped=true"
import script from "./LoginFormEmail.vue?vue&type=script&lang=js"
export * from "./LoginFormEmail.vue?vue&type=script&lang=js"

import "./LoginFormEmail.vue?vue&type=style&index=0&id=87fab222&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87fab222"]])

export default __exports__